module.exports = __webpack_public_path__ + "img/dollar-symbol.8a97f5e6.svg";